import { useEffect, useReducer } from "react";

import Header from "./Header";
import Main from "./Main";
import Loader from "./Loader";
import Error from "./Error";
import StartScreen from "./StartScreen";
import Question from "./Question";
import NextButton from "./NextButton";
import Progress from "./Progress";
import FinishScreen from "./FinishScreen";
import Footer from "./Footer";
import Timer from "./Timer";
import BackButton from "./BackButton";

const initialState = {
  questions: [],
  answers: [],

  // 'General', 'Easy', 'Medium', 'Hard'
  level: null,

  // 'loading', 'error', 'ready', 'active', 'finished'
  status: "loading",
  index: 0,
  points: 0,
  highscore: 0,
  secondsRemaining: null,
};

function reducer(state, action) {
  switch (action.type) {
    case "dataRecevied":
      return {
        ...state,
        questions: action.payload.questions,
        answers: new Array(action.payload.questions.length).fill(null),
        status: "ready",
        highscore: action.payload.highscore,
      };
    case "dataFailed":
      return { ...state, status: "error" };
    case "setLevel":
      const generalQuestions = state.questions;
      const easyQuestions = state.questions.filter(
        (question) => question.points === 10
      );
      const mediumQuestions = state.questions.filter(
        (question) => question.points === 20
      );
      const hardQuestions = state.questions.filter(
        (question) => question.points === 30
      );
      let selectedQuestions;
      if (action.payload === "General") selectedQuestions = generalQuestions;
      if (action.payload === "Easy") selectedQuestions = easyQuestions;
      if (action.payload === "Medium") selectedQuestions = mediumQuestions;
      if (action.payload === "Hard") selectedQuestions = hardQuestions;
      if (action.payload === null) selectedQuestions = generalQuestions;
      return {
        ...state,
        level: action.payload,
        questions: selectedQuestions,
      };

    case "start":
      let SECS_PER_QUESTION;
      if (state.level === "General") SECS_PER_QUESTION = 20;
      if (state.level === "Easy") SECS_PER_QUESTION = 10;
      if (state.level === "Medium") SECS_PER_QUESTION = 20;
      if (state.level === "Hard") SECS_PER_QUESTION = 30;
      return {
        ...state,
        status: "active",
        secondsRemaining: state.questions.length * SECS_PER_QUESTION,
      };
    case "newAnswer":
      const question = state.questions.at(state.index);
      const answersCopy = state.answers.slice();
      answersCopy[state.index] = action.payload;
      return {
        ...state,
        answers: answersCopy,
        points:
          action.payload === question.correctOption
            ? state.points + question.points
            : state.points,
      };
    case "nextQuestion":
      return { ...state, index: state.index + 1 };
    case "backQuestion":
      return { ...state, index: state.index - 1 };
    case "finish":
      return {
        ...state,
        status: "finished",
        highscore:
          state.points > state.highscore ? state.points : state.highscore,
      };
    case "restart":
      return {
        ...initialState,
        questions: state.questions,
        answers: new Array(state.questions.length).fill(null),
        status: "ready",
        highscore: state.highscore,
      };
    case "tick":
      return {
        ...state,
        secondsRemaining: state.secondsRemaining - 1,
        status: state.secondsRemaining === 0 ? "finished" : state.status,
      };

    default:
      throw Error("Action Unknown");
  }
}

export default function App() {
  const [
    {
      level,
      questions,
      status,
      index,
      answers,
      points,
      highscore,
      secondsRemaining,
    },
    dispatch,
  ] = useReducer(reducer, initialState);

  const numQuestions = questions.length;
  const maxPossiblePoints = questions.reduce(
    (prev, cur) => prev + cur.points,
    0
  );

  //   // useEffect(function () {
  // //   fetch("http://localhost:8000/questions")
  // //     .then((res) => res.json())
  // //     .then((data) => dispatch({ type: "dataRecevied", payload: data }))
  // //     .catch((err) => dispatch({ type: "dataFailed" }));
  // // }, []);

  // useEffect(function () {
  //   Promise.all([
  //     fetch("http://localhost:8000/questions"),
  //     fetch("http://localhost:8000/highscore"),
  //   ])
  //     .then(([questionsRes, highscoreRes]) =>
  //       Promise.all([questionsRes.json(), highscoreRes.json()])
  //     )
  //     .then(([questionsData, highscoreData]) =>
  //       dispatch({
  //         type: "dataRecevied",
  //         payload: {
  //           questions: questionsData,
  //           highscore: highscoreData.value,
  //         },
  //       })
  //     )
  //     .catch((err) => dispatch({ type: "dataFailed" }));
  // }, []);

  // useEffect(
  //   function () {
  //     if (status !== "finished" || highscore > points) return;
  //     fetch("http://localhost:8000/highscore", {
  //       method: "PATCH",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ value: highscore }),
  //     }).catch((err) => dispatch({ type: "dataFailed" }));
  //   },
  //   [highscore, points, status]
  // );

  useEffect(function () {
    fetch("https://abd-alrahan.github.io/question-s-server/db.json")
      .then((res) => res.json())
      .then((data) => {
        const savedHighscore = JSON.parse(localStorage.getItem("highscore"));
        dispatch({
          type: "dataRecevied",
          payload: {
            questions: data.questions,
            highscore: savedHighscore ?? data.highscore.value,
          },
        });
      })
      .catch((err) => dispatch({ type: "dataFailed" }));
  }, []);

  useEffect(
    function () {
      if (status !== "finished" || highscore > points) return;
      try {
        localStorage.setItem("highscore", JSON.stringify(highscore));
      } catch (err) {
        dispatch({ type: "dataFailed" });
      }
    },
    [highscore, points, status]
  );

  return (
    <div className="app">
      <Header />
      <Main>
        {status === "loading" && <Loader />}
        {status === "error" && <Error />}
        {status === "ready" && (
          <StartScreen
            level={level}
            numQuestions={numQuestions}
            dispatch={dispatch}
          />
        )}
        {status === "active" && (
          <>
            <Progress
              index={index}
              numQuestions={numQuestions}
              points={points}
              maxPossiblePoints={maxPossiblePoints}
              answers={answers}
            />
            <Question
              question={questions[index]}
              answer={answers[index]}
              dispatch={dispatch}
            />
            <Footer>
              <Timer dispatch={dispatch} secondsRemaining={secondsRemaining} />
              <NextButton
                dispatch={dispatch}
                index={index}
                numQuestions={numQuestions}
              />
              <BackButton dispatch={dispatch} index={index} />
            </Footer>
          </>
        )}
        {status === "finished" && (
          <FinishScreen
            points={points}
            maxPossiblePoints={maxPossiblePoints}
            highscore={highscore}
            dispatch={dispatch}
          />
        )}
      </Main>
    </div>
  );
}
